import React from 'react';

function Privacy() {
    return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Política de Privacidad</h1>

        <p>
          Tu privacidad es importante para mí. En esta declaración de privacidad te explico qué datos personales recopilo de mis usuarios y cómo los utilizo. Te animo a leer detenidamente estas políticas antes de facilitar tus datos personales en esta web{' '}
          <a href="https://moneymoveroficial.com/">https://moneymoveroficial.com/</a>.
        </p>

        <p>En esta web se respeta y cuida los datos personales de los usuarios. Como usuario debes saber que tus derechos están garantizados.</p>

        <ul>
          <li>Nunca solicito información personal a menos que realmente sea necesaria para prestarte los servicios que me requieras.</li>
          <li>Nunca comparto información personal de mis usuarios con nadie, excepto para cumplir con la ley o en caso que cuente con tu autorización expresa.</li>
          <li>Nunca utilizo tus datos personales con una finalidad diferente a la expresada en esta política de privacidad.</li>
        </ul>

        <p>
          Es preciso advertir que esta Política de Privacidad podría variar en función de exigencias legislativas o de autorregulación, por lo que se aconseja a los usuarios que la visiten periódicamente. Será aplicable en caso de que los usuarios decidan rellenar algún formulario de contacto donde se recaben datos de carácter personal.
        </p>

        <h2>Principios que aplicaré a tu información personal</h2>
        <p>
          En el tratamiento de tus datos personales, aplicaré los siguientes principios que se ajustan a las exigencias del nuevo reglamento europeo de protección de datos:
        </p>
        <ul>
          <li><strong>Principio de licitud, lealtad y transparencia:</strong> Siempre voy a requerir tu consentimiento para el tratamiento de tus datos personales para uno o varios fines específicos que te informaré previamente con absoluta transparencia.</li>
          <li><strong>Principio de minimización de datos:</strong> Solo voy a solicitar datos estrictamente necesarios en relación con los fines para los que los requiero. Los mínimos posibles.</li>
          <li><strong>Principio de limitación del plazo de conservación:</strong> Los datos serán mantenidos durante no más tiempo del necesario para los fines del tratamiento, en función de la finalidad.</li>
          <li><strong>Principio de integridad y confidencialidad:</strong> Tus datos serán tratados de tal manera que se garantice una seguridad adecuada de los datos personales y se garantice confidencialidad.</li>
        </ul>

        <h2>¿Cómo he obtenido tus datos?</h2>
        <p>
          Los datos personales que trato en{' '}
          <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a> y la herramienta Kyc proceden de:
        </p>
        <ul>
          <li>Formulario de contacto</li>
          <li>Email</li>
          <li>Dirección</li>
          <li>Video identificación</li>
        </ul>

        <h2>¿Cuáles son tus derechos cuando me facilitas tus datos?</h2>
        <p>Cualquier persona tiene derecho a obtener confirmación sobre si en <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a> estoy tratando datos personales que me concierne, o no.</p>
        <p>Las personas interesadas tienen derecho a:</p>
        <ul>
          <li>Solicitar el acceso a los datos personales relativos al interesado</li>
          <li>Solicitar su rectificación o supresión</li>
          <li>Solicitar la limitación de su tratamiento</li>
          <li>Oponerse al tratamiento</li>
          <li>Solicitar la portabilidad de los datos</li>
        </ul>

        <h2>¿Con qué finalidad trato tus datos personales?</h2>
        <p>
          Cuando un usuario se conecta con esta web, por ejemplo, para comentar un post, mandar un correo al titular, suscribirse o realizar alguna contratación, está facilitando información de carácter personal de la que es responsable{' '}
          <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a>.
        </p>
        <p>Esa información puede incluir datos de carácter personal como pueden ser tu dirección IP, nombre, dirección de correo electrónico, número de teléfono, y otra información.</p>

        <h2>Legitimación para el tratamiento de tus datos</h2>
        <p>La base legal para el tratamiento de sus datos es el consentimiento.</p>

        <h2>¿Por cuánto tiempo conservaré tus datos?</h2>
        <p>Los datos personales proporcionados se conservarán lo que estipula la ley y hasta que se solicite su supresión por el interesado.</p>

        <h2>¿A qué destinatarios se comunicarán tus datos?</h2>
        <p>Muchas herramientas que utilizo para gestionar tus datos son contratados por terceros.</p>

        <h2>Navegación</h2>
        <p>
          Al navegar por <a href="https://moneymoveroficial.com/">https://moneymoveroficial.com/</a> se pueden recoger datos no identificables, como direcciones IP, ubicación geográfica, y un registro de cómo se utilizan los servicios y sitios.
        </p>

        <h2>Secreto y seguridad de los datos</h2>
        <p>
          <a href="https://moneymoveroficial.com/">https://moneymoveroficial.com</a> se compromete en el uso y tratamiento de los datos personales de los usuarios, respetando su confidencialidad y a utilizarlos de acuerdo con la finalidad del mismo.
        </p>

        <h2>Aceptación y consentimiento</h2>
        <p>
          El usuario declara haber sido informado de las condiciones sobre protección de datos de carácter personal, aceptando y consintiendo el tratamiento de los mismos por parte de{' '}
          <a href="https://moneymoveroficial.com/">https://moneymoveroficial.com</a> en la forma y para las finalidades indicadas en esta política de privacidad.
        </p>

        <h2>Correos comerciales</h2>
        <p>
          De acuerdo con la LSSICE, <a href="https://moneymoveroficial.com/">https://moneymoveroficial.com</a> no realiza prácticas de SPAM, por lo que no envía correos comerciales no solicitados o autorizados.
        </p>

      </div>
    </div>
  );

};

export  {Privacy};

